<template>
  <div>
    <div class="m-steps">
      <Steps :space="200" :lineCustomStyle="{ background: '#cb921b', width: '5px' }">
        <Step>
          <span class="m-steps_icon" slot="icon">巡查</span>
          <div slot="content" class="m-steps_content">
            <Inspection :file-list="formData.inspectionAttachmentRespList" />
          </div>
        </Step>
        <Step>
          <span class="m-steps_icon" slot="icon">采摘</span>
          <div slot="content" class="m-steps_content">
            <Weight :formData="formData" />
          </div>
        </Step>
        <Step>
          <span class="m-steps_icon" slot="icon">运输</span>
          <div slot="content" class="m-steps_content">
            <Transport :formData="formData" />
          </div>
        </Step>
      </Steps>
    </div>
  </div>
</template>

<script>
import { Steps, Step } from '@/components/Steps/index'
import Inspection from './Inspection'
import Weight from './Weight/index.vue'
import Transport from './Transport/index.vue'

export default {
  name: 'TaskProcess',
  components: {
    Steps,
    Step,
    Inspection,
    Weight,
    Transport,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
   
  },
}
</script>

<style scoped lang="less">
.m-steps {
  &_icon {
    box-sizing: border-box;
    display: inline-block;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 40px;
    border: 5px solid #cb921b;
    border-radius: 50%;
    background-color: #fff;
  }

  &_content {
    padding-left: 20px;
  }
}
</style>
